import { render } from "./ArticleLabel.vue?vue&type=template&id=02bfcd7a&ts=true"
import script from "./ArticleLabel.vue?vue&type=script&lang=ts"
export * from "./ArticleLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__